/*
 * You can import any JS files from node_modules here
 */
import 'jquery/dist/jquery.min';
import './common'

